<template>
  <DialogTemplate
    data-tst="solfigr_rakedialog"
    style="--dialog-content-overflow: none"
  >
    <div
      class="f-column"
      style="gap: 1rem"
    >
      <div class="text-large my-auto weight_700 text-nowrap">
        {{ $t('solfigr.icm.save_tournament_preset') }}
      </div>
      <div class="f-column">
        <GwInput
          :label="$t('common.name')"
          style="--input-height: 2.5rem"
          type="text"
          autofocus
          :getErrors
          :value="l_item.name"
          @input="(_e, value) => (l_item.name = value.trim())"
          @keydown:enter="apply"
        />

        <SolfigrIcmTournamentStructureItem
          style="--clr-box-back: var(--clr-black-1-3)"
          :item="{ ...l_item, name: '' }"
          class="mt-2 gw_box"
        />
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        data-tst="btn_close"
        variant="text"
        @click="close"
        >{{ $t('btn.close') }}</v-btn
      >
      <v-btn
        class="ml-2"
        data-tst="btn_save"
        color="primary"
        :loading="save_call.loading"
        :disabled="!!(getErrors().length || !l_item || !l_item.name)"
        @click="apply"
        >{{ $t('btn.save') }}</v-btn
      >
    </template>
  </DialogTemplate>
</template>

<script>
import SolfigrIcmTournamentStructureItem from '@/components/Dialogs/Solfigr/SolfigrIcmTournamentStructureItem'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import GwInput from '@/components/lib/GwInput'
import fetch_mix from '@/mixins/fetch_mix'

export default {
  name: 'SolfigrIcmStructuresSaveDialog',
  components: {
    GwInput,
    SolfigrIcmTournamentStructureItem,
    DialogTemplate,
  },
  mixins: [fetch_mix],
  props: {
    dialog: Object,
  },
  data() {
    return {
      l_item: null,
      nameError: false,

      save_call: {
        conf: {
          method: 'post',
          endpoint: 'tournaments/preset/',
          apiVersion: 'v4',
          data: {},
        },
        loading: false,
        loaded: false,
        status: 0,
        error: null,
      },
    }
  },
  created() {
    this.l_item = { ...this.$store.getters[`${this.namespace}/slfrm_icm_tournament`] }
  },
  methods: {
    getErrors() {
      if ((this.l_item?.name || '').trim().length > 255) {
        return [this.$t(`messages.field_name_too_many_characters`, { max_chars: 255 })]
      }
      if (!(this.l_item?.name || '').trim().length) {
        return [this.$t(`messages.field_empty_error`)]
      }
      return []
    },
    async apply() {
      if (this.getErrors().length) return
      if (this.save_call.loading) return

      this.save_call.conf.data = this.l_item
      const { data, error } = await this.fch_getData(this.save_call)
      if (error) {
        this.$store.dispatch('messages', {
          type: 'error',
          text: this.$t('messages.error_success_preset_create', { status: this.save_call.status }),
        })
        return
      }
      this.$store.dispatch('messages', {
        type: 'success',
        text: this.$t('messages.success_preset_create'),
        hide: true,
      })
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-icm-structures-save-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || null
    },
  },
}
</script>
